import $root from '@/proto/proto-bundle'

export const FileService = {
  decodeDownload: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('DownloadPresignedUrlResponse')
    resolve(container.decode(new Uint8Array(body)))
  }),
  encodeUpdateFileRequest: ({ name, size }) => new Promise((resolve) => {
    const requestBuilder = $root.lookup('UpdateFileRequest')
    resolve(requestBuilder.encode({ name, size }).finish())
  }),
  decodeUpdateFileResponse: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('UpdateFileResponse')
    resolve(container.decode(new Uint8Array(body)))
  }),
  encodeFilePresignedUrlRequest: (item) => new Promise((resolve) => {
    const requestBuilder = $root.lookup('FilePresignedUrlRequest')
    resolve(requestBuilder.encode(item).finish())
  }),
  decodeFilePresignedUrlResponse: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('FilePresignedUrlResponse')
    resolve(container.decode(new Uint8Array(body)))
  }),
  encodeStatus: (status) => new Promise((resolve) => {
    const requestBuilder = $root.lookup('Status')
    resolve(requestBuilder.encode(status).finish())
  }),
  decodeShareLinkResponse: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('ShareLinkResponse')
    resolve(container.decode(new Uint8Array(body)))
  })
}
